import React from 'react';
import {Box, Heading, Image, Input, Select, Tooltip,SlideFade, Text, RangeSlider, RangeSliderFilledTrack, RangeSliderThumb, RangeSliderTrack} from '@chakra-ui/react'
import CustomButton from '../../../../elements/customButton'
import CircleIcon from '../../../../../assets/images/cardCircle.svg'
import AddIcon from '../../../../../assets/images/addFile.svg'
import moment from 'moment'
import { InfoOutlineIcon } from '@chakra-ui/icons'

export default function LoanCardBussines(props) {
    return (
        <Box className='form_block' mb={5}>
            <Box mb={3} className='form_inputs'>
                <Heading as="h5" className='font-poppins'>Loan Type</Heading>
                <Input size="md" name="loan_type" type="text" className="input_box font-poppins" value={props?.item.name} isReadOnly />
            </Box>
            {
                 props?.productIdData == 17 &&
                <Box mb={3} className='form_inputs'>
                                    <Heading as="h5" className='font-poppins'>Invoice Amount</Heading>
                                    <Input size="md" name="invoice_amount"  type="text" placeholder="Please Enter Invoice Amount" className="input_box font-poppins"
                                        onChange={props.onChangeFunction} value={props.inputValuesBusin?.invoice_amount ?? ''}
                                    />
                                </Box>
            }
                                <Box mb={3} className='form_inputs'>
                                     <Heading as="h5" className='font-poppins'>Loan Amount</Heading>
                                     <Input size="md" name="loan_amount"  type="text" placeholder="Please Enter Loan Amount" className="input_box font-poppins"
                                         onChange={props.onChangeFunction} value={props.inputValuesBusin?.loan_amount ?? ''}
                                     />
                                 </Box>
                                 <Box mb={3} className='form_inputs'>
                                    {
                                        props?.productIdData == 17 ?
                                     <Heading as="h5" className='font-poppins'>Loan Tenure (Days)</Heading>
                                     :
                                     <Heading as="h5" className='font-poppins'>Loan Tenure (Month)</Heading>
                                        
                                    }
                                     {/* <Heading as="h5" className='font-poppins'>Loan Tenure (Days)</Heading> */}
                                     <Input size="md" name="loan_tenure"  type="text" placeholder="Please Enter Loan Tenure" className="input_box font-poppins"
                                         onChange={props.onChangeFunction} value={props.inputValuesBusin?.loan_tenure ?? ''}
                                     />
                                 </Box>
                                 {
                                     props?.productIdData == 17 && 
                                     <>
                                     <Box mb={3} className='form_inputs'>
                                     <Heading as="h5" className='font-poppins'>Date Of Issuance Of Invoice </Heading>
                     <Input size="md" name="invoice_issue_date" type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                     onChange={props.onChangeFunction} value={moment(props.inputValuesBusin.invoice_issue_date).format('YYYY-MM-DD') ?? ""}
                     // value={moment(props.inputValuesBusin.invoice_issue_date).isValid() ? moment(props.inputValuesBusin.invoice_issue_date).format('DD-MM-YYYY') : ""}
                     // value={moment(inputValues?.to_date, 'DD-MM-YYYY').format('YYYY-MM-DD') }
                     />
                      </Box>
                      <Box mb={3} className='form_inputs'>
                                                    <Heading as="h5" className='font-poppins'>Invoice Payment Date</Heading>
                                    <Input size="md" name="invoice_payment_date" type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                                    // onChange={props.onChangeFunction} value={moment(props.inputValuesBusin.invoice_payment_date).format('DD-MM-YYYY') ?? ""}
                                    onChange={props.onChangeFunction} value={moment(props.inputValuesBusin.invoice_payment_date).format('YYYY-MM-DD') ?? ""}
                                    />
                                </Box>
                                <Box mb={3} className='form_inputs'>
                                    <Heading as="h5" className='font-poppins'>Credit Period</Heading>
                                    <Input size="md" name="credit_period"  type="number" placeholder="Please Enter Credit Period" className="input_box font-poppins"
                                         onChange={props.onChangeFunction} value={props.inputValuesBusin.credit_period ?? ""}
                                    />
                                     
                                </Box> 
                                     </>
                                 }
                                <Box mb={3} className='form_inputs'>
                                    <Heading as="h5" className='font-poppins'>Work Experience /Company Establishment(In Months)</Heading>
                                    <Input size="md" name="company_establishment"  type="text" placeholder="Please Enter  Company Establishment In Months" className="input_box font-poppins"
                                        onChange={props.onChangeFunction} value={props.inputValuesBusin?.company_establishment ?? ''}
                                    />
                                </Box>
                                {
                                     props?.productIdData == 10 && 
                                     <Box mb={3} className='d-flex align-items-center justify-content-between col-gap-15'>
                <Box className='form_inputs'>
                    <Heading as="h5" className='font-poppins'>Loan Purpose</Heading>
                    <Select placeholder="Please Select Business Loan Purpose" variant="filled" className="font-poppins input_box_select"
                        name="loan_purpose" onChange={props.onChangeFunction} value={props.inputValuesBusin?.loan_purpose ?? ''}>
                        {props?.loanPurposeOptions?.map((item, index) => {
                            return (
                                <option key={index} value={item.value}>{item.value}</option>
                            )
                        })}
                    </Select>
                </Box>
                </Box>
                                }
                                <Box mb={3} className='form_inputs expected_roi'>
                    <Heading as="h5" className='font-poppins'>Expected ROI<span>(Range 23% to 41%)</span></Heading>
                    <Box className='d-flex align-items-center col-gap-25'>
                        <RangeSlider value={props?.expectedROIValue?.roi} min={23} max={41} step={0.1}
                            onChange={(e) => props.handleExpectedROIValue(e, 'roi')} >
                            <RangeSliderTrack className='range_slider_bg'>
                                <RangeSliderFilledTrack bg='#BA1F33' />
                            </RangeSliderTrack>
                            <RangeSliderThumb boxSize={6} index={0} className='left_thumb' />
                            <RangeSliderThumb boxSize={6} index={1} className='right_thumb' />
                        </RangeSlider>
                        <Box className='loan_block roi_data'>
                            <Heading as="h5" className='font-poppins'>{props?.expectedROIValue?.roi[1]}%</Heading>
                        </Box>
                    </Box>
                </Box>
                                <Box mb={3} className='form_inputs'>
                                    <Heading as="h5" className='font-poppins'>Average Annual Turnover</Heading>
                                    <Input size="md" name="avg_annual_turnover"  type="text" placeholder="Please Enter  Average Annual Turnover" className="input_box font-poppins"
                                        onChange={props.onChangeFunction} value={props.inputValuesBusin?.avg_annual_turnover ?? ''}
                                    />
                                </Box>
                            
            <Box mb={3} className='d-flex align-items-center justify-content-between col-gap-15'>
                <Box className='form_inputs'>
                    <Heading as="h5" className='font-poppins'>Business Premise Ownership</Heading>
                    <Select placeholder="Please Select Business Premise Ownership" variant="filled" className="font-poppins input_box_select"
                        name="buss_premise_ownership" onChange={props.onChangeFunction} value={props.inputValuesBusin?.buss_premise_ownership ?? ''}>
                        {props?.premisesBusinessOptions?.map((item, index) => {
                            return (
                                <option key={index} value={item.key}>{item.value}</option>
                            )
                        })}
                    </Select>
                </Box>
            </Box>
                <Box mb={4} className='d-flex justify-content-start col-gap-15'>
                    {
                            props?.productIdData == 17 && 
                            <>
                              <Box className='form_inputs_upload form_inputs'>
                            <Heading as="h5" className="font-poppins label_heading">Invoice Copies
                  <Tooltip label="Copies of all invoices to be financed clubbed in a single document duly verified and accepted by the customer."  hasArrow fontSize='xs' placement='bottom-start'>
                    <InfoOutlineIcon ml={1} />
                  </Tooltip>
                </Heading>
                            <Box>
                                <CustomButton
                                    className="btn_transparent_red font-poppins col-gap-10 w-100"
                                    title="Browse"
                                    onClick={() => props.showOpenFileDialogFunction('invoice_copy')}
                                    leftIcon={<Image src={AddIcon} />}
                                />
                                <Input
                                    size="md"
                                    name="upload"
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => props.onChangeFileFunction(e, 'invoice_copy')}
                                    className="d-none"
                                    ref={props.InvoiceRefprop}
                                />
                                <Text className='font-poppins note file_name'>{props?.Invoice_Statement?.name}</Text>
                            </Box>
                        </Box>
                             <Box className='form_inputs_upload form_inputs'>
                             <Heading as="h5" className="font-poppins label_heading">Proof Of Delivery (Optional)
                   <Tooltip label="AVERAGE Annual Turnover (Preceding Financial year)"  hasArrow fontSize='xs' placement='bottom-start'>
                     <InfoOutlineIcon ml={1} />
                   </Tooltip>
                 </Heading>
                             <Box>
                                 <CustomButton
                                     className="btn_transparent_red font-poppins col-gap-10 w-100"
                                     title="Browse"
                                     onClick={() => props.showOpenFileDialogFunction('proof_of_delivery')}
                                     leftIcon={<Image src={AddIcon} />}
                                 />
                                 <Input
                                     size="md"
                                     name="upload"
                                     type="file"
                                     accept=".pdf"
                                     onChange={(e) => props.onChangeFileFunction(e, 'proof_of_delivery')}
                                     className="d-none"
                                     ref={props.PrrofdelliveryRefprop}
                                 />
                                 <Text className='font-poppins note file_name'>{props?.Proof_Delivery_Statement?.name}</Text>
                             </Box>
                         </Box>
                            </>
                          
                    }
                    <Box className='form_inputs_upload form_inputs'>
                        <Heading as="h5" className="font-poppins label_heading">ITR
              <Tooltip label="ITR filings for the last financial year in the name of the business, or a declaration that the business is not filing ITR."  hasArrow fontSize='xs' placement='bottom-start'>
                <InfoOutlineIcon ml={1} />
              </Tooltip>
            </Heading>
                        <Box>
                            <CustomButton
                                className="btn_transparent_red font-poppins col-gap-10 w-100"
                                title="Browse"
                                onClick={() => props.showOpenFileDialogFunction('itr_proof')}
                                leftIcon={<Image src={AddIcon} />}
                            />
                            <Input
                                size="md"
                                name="upload"
                                type="file"
                                accept=".pdf"
                                onChange={(e) => props.onChangeFileFunction(e, 'itr_proof')}
                                className="d-none"
                                ref={props.itrRefprop}
                            />
                            <Text className='font-poppins note file_name'>{props?.itrStatementData?.name}</Text>
                            <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="itr_form16_password"
                                                    value={props?.inputValuesBusin?.itr_form16_password ?? ''}
                                                />
                        </Box>
                    </Box>

                </Box>
             
                    <Box mb={4} className='d-flex justify-content-start col-gap-15'>
                  
                    <Box className='form_inputs_upload form_inputs'>
                            <Heading as="h5" className="font-poppins label_heading">GST Submission
                  <Tooltip label="GST submissions for the preceding 12 months at the time of application."  hasArrow fontSize='xs' placement='bottom-start'>
                    <InfoOutlineIcon ml={1} />
                  </Tooltip>
                </Heading>
                            <Box>
                                <CustomButton
                                    className="btn_transparent_red font-poppins col-gap-10 w-100"
                                    title="Browse"
                                    onClick={() => props.showOpenFileDialogFunction('gst_paid_submission')}
                                    leftIcon={<Image src={AddIcon} />}
                                />
                                <Input
                                    size="md"
                                    name="upload"
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => props.onChangeFileFunction(e, 'gst_paid_submission')}
                                    className="d-none"
                                    ref={props.gstSubmissionprop}
                                />
                                <Text className='font-poppins note file_name'>{props?.GstPaid_Statement?.name}</Text>
                            </Box>
                        </Box>
                        
                        <Box className='form_inputs_upload form_inputs' style={{width:"323px"}}>
                            {/* <Heading as="h5" className='font-poppins'>Bank Statement<span>(Current Financial Year till Date)</span></Heading> */}
                            <Heading as="h5" classNa me='font-poppins'>Bank Statement<span>(Current Financial Year till Date)</span>
                </Heading>
                            <Box>
                                <CustomButton
                                    className="btn_transparent_red font-poppins col-gap-10 w-100"
                                    title="Browse"
                                    onClick={() => props.showOpenFileDialogFunction('bank_statement')}
                                    leftIcon={<Image src={AddIcon} />}
                                />
                                <Input
                                    size="md"
                                    name="upload"
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => props.onChangeFileFunction(e, 'bank_statement')}
                                    className="d-none"
                                    ref={props.bankRefprop}
                                />
                                <Text className='font-poppins note file_name'>{props?.bank_Statement?.name}</Text>
                                <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="bank_stmt1_password"
                                                    value={props?.inputValuesBusin?.bank_stmt1_password ?? ''}
                                                />
                            </Box>
                        </Box>
                       
                 </Box>
                
              
             {/* <Box mb={4} className='d-flex justify-content-start col-gap-15'>
                    </Box> */}
                    
                    <Box className='form_inputs_upload form_inputs' width="323px">
                        <Heading as="h5" className='font-poppins'>Bank Statement<span>(Preceding Financial year)</span></Heading>
                        <Box>
                            <CustomButton
                                className="btn_transparent_red font-poppins col-gap-10 w-100"
                                title="Browse"
                                onClick={() => props.showOpenFileDialogFunction('bank_statement_2')}
                                leftIcon={<Image src={AddIcon} />}
                            />
                            <Input
                                size="md"
                                name="upload"
                                type="file"
                                accept=".pdf"
                                onChange={(e) => props.onChangeFileFunction(e, 'bank_statement_2')}
                                className="d-none"
                                ref={props.BankStatRefprop}
                            />
                            <Text className='font-poppins note file_name'>{props?.BankStatement2_Statement?.name}</Text>
                            <Input
                                                    size="md"
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    onChange={props.handleChange}
                                                    mt={4}
                                                    name="bank_stmt2_password"
                                                    value={props?.inputValuesBusin?.bank_stmt2_password ?? ''}
                                                />
                        </Box>
                    </Box>
                    {
                        props?.user_Data?.cp_id &&
                        <Box className='form_inputs_upload form_inputs' width="323px">
                        <Box className='form_inputs_upload form_inputs' width="323px">
                        <Heading as="h5" className='font-poppins'>Post Dated Cheque <span>(Optional)</span></Heading>
                        <Box>
                            <CustomButton
                                className="btn_transparent_red font-poppins col-gap-10 w-100"
                                title="Browse"
                                onClick={() => props.showOpenFileDialogFunction('pdc')}
                                leftIcon={<Image src={AddIcon} />}
                            />
                            <Input
                                size="md"
                                name="upload"
                                type="file"
                                accept=".pdf"
                                onChange={(e) => props.onChangeFileFunction(e, 'pdc')}
                                className="d-none"
                                ref={props.PDC_pdc_Ref}
                            />
                            <Text className='font-poppins note file_name'>{props?.pdcDataStatement?.name}</Text>
                        </Box>
                    </Box>
                    <Box className='form_inputs_upload form_inputs' width="323px">
                        <Heading as="h5" className='font-poppins'>CP Credit Assessment <span>(Optional)</span></Heading>
                        <Box>
                            <CustomButton
                                className="btn_transparent_red font-poppins col-gap-10 w-100"
                                title="Browse"
                                onClick={() => props.showOpenFileDialogFunction('cp_assesment')}
                                leftIcon={<Image src={AddIcon} />}
                            />
                            <Input
                                size="md"
                                name="upload"
                                type="file"
                                accept=".pdf"
                                onChange={(e) => props.onChangeFileFunction(e, 'cp_assesment')}
                                className="d-none"
                                ref={props.CpAssesmentRef}
                            />
                            <Text className='font-poppins note file_name'>{props?.cpAssesmentStatement?.name}</Text>
                        </Box>
                    </Box>
                        </Box>
                    }
                    
            <Box className='d-flex justify-content-end apply_btn'>
                <CustomButton size="md" type="submit" title="Apply" className="btn_theme font-poppins"
                    onClick={() => props.handleApplyLoanFun(props.item.product_id)}
                />
            </Box>
        </Box>
  
    
                  
                          
    
    );
}

